import React, { FunctionComponent } from "react";
import { TableBody as MUITableBody } from "@material-ui/core";
import { SystemEmailTemplate } from "model/SystemEmailTemplate";
import TemplateRow from "../TemplateRow";

interface Props {
  templates: Array<SystemEmailTemplate>;
  onSelect: (template: SystemEmailTemplate) => void;
}

export const TableBody: FunctionComponent<Props> = ({ templates, onSelect }) => {
  return (
    <MUITableBody>
      {templates.map(template => (
        <TemplateRow
          key={template.id}
          template={template}
          onSelect={onSelect}
        />
      ))}
    </MUITableBody>
  );
};

export default TableBody;
